import { makeBinding, parseTarget, sourceKey } from '~/lib/input/model'

// Rehydrate hard-sets stored keys, so each binding is re-run through `makeBinding`: new fields get defaults, unusable ones drop.
export default function reconcileInput(persisted, current) {
	const bindings = []
	for (const b of persisted?.bindings ?? []) {
		if (!b || !sourceKey(b.source)) continue
		const next = makeBinding(b)
		next.targets = next.targets.filter(t => parseTarget(t.target))
		if (next.targets.length) bindings.push(next)
	}
	const disabledInputs = (persisted?.disabledInputs ?? []).filter(k => typeof k === 'string')
	return { ...current, bindings, midiOn: !!persisted?.midiOn, disabledInputs }
}
